import React from 'react'

const Pagination = ({ nPages, disabled, setDisabled, currentPage, setCurrentPage }) => {

const pageNumbers = [...Array(nPages + 1).keys()].slice(1)

    const nextPage = () => {
        if(currentPage != nPages){
          setCurrentPage(currentPage + 1)
        }else if(currentPage === nPages) {
           setCurrentPage(currentPage)
        }
    }
    const prevPage = () => {
        if(currentPage !== 1) setCurrentPage(currentPage - 1)
    }
    return (
        <nav>
            <ul className='pagination pagination-lg justify-content-center'>
                <li className="page-item">
                    <a className="page-link"
                        onClick={prevPage}
                        href='#'>

                        Previous
                    </a>
                </li>
                {pageNumbers.map(pgNumber => (
                    <li key={pgNumber}
                        className= {`page-item ${currentPage == pgNumber ? 'active' : ''} `} >

                        <a onClick={() => setCurrentPage(pgNumber)}
                            className='page-link'
                            href='#'>
                        </a>
                    </li>
                ))}
                <li className="page-item">
                    <a className="page-link"
                    href='#'
                        onClick={nextPage}>
                        Next
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export default Pagination
